<!-- EntityConfigurationOCR -->
<ion-col class="flex-align-center">
    <ion-grid>
        <ion-row>
            <ion-col size="12">
                <h2 class="page-title">Configurações de OCR</h2>
            </ion-col>
        </ion-row>

        <ion-row *ngFor="let item of config?.ConfigList">
            <ion-col size="12">
                <ion-card>
                    <ion-card-header>
                        <ion-card-title>
                            {{ getOCRTypeName(item?.Type?.Id) }}
                            <ion-badge color="primary">
                                {{ item?.Module?.Name }}
                            </ion-badge>
                        </ion-card-title>
                    </ion-card-header>

                    <ion-card-content>
                        <!-- Informações Básicas -->
                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="information-circle-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">ID</span>
                                    <span class="detail-value">{{ item?.Id }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="calendar-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Criado em</span>
                                    <span class="detail-value">{{ item?.CreateDate | date:'medium' }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="person-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Criado por</span>
                                    <span class="detail-value">{{ item?.CreateUser }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Tipo e Módulo -->
                        <ion-item-divider>
                            <ion-label>Tipo e Módulo</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="document-text-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Tipo de OCR</span>
                                    <span class="detail-value">
                                        <ion-badge color="secondary">{{ item?.Type?.Name }}</ion-badge>
                                    </span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="cube-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Módulo</span>
                                    <span class="detail-value">
                                        <ion-badge color="tertiary">{{ item?.Module?.Name }}</ion-badge>
                                        <span class="module-id">(ID: {{ item?.Module?.Id }})</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Configurações específicas por tipo -->
                        <div class="detail-grid single-col" *ngIf="item?.Type?.Id === '1'">
                            <div class="detail-item">
                                <ion-icon name="search-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Identificadores de Fatura</span>
                                    <span class="detail-value">Esta configuração define os padrões para
                                        identificação de faturas no módulo {{ item?.Module?.Name }}.</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid single-col" *ngIf="item?.Type?.Id === '2'">
                            <div class="detail-item">
                                <ion-icon name="ban-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Lista Negra</span>
                                    <span class="detail-value">Esta configuração contém termos ou padrões que devem
                                        ser ignorados no processamento OCR para o módulo {{ item?.Module?.Name
                                        }}.</span>
                                </div>
                            </div>
                        </div>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-col>
